/* eslint-disable import/prefer-default-export */
const cardAPIMap = {
  '/city/mumbai': '/card-inserts/web/city/mumbai_lite.json',
  '/sports/tokyo-olympics-2021':
    '/card-inserts/web/sports/tokyo-olympics-2021_lite.json',
  '/sports/cricket/icc-mens-t20-world-cup':
    '/card-inserts/web/sports/cricket/icc-mens-t20-world-cup_lite.json',
  '/business/cryptocurrency':
    '/card-inserts/web/business/cryptocurrency_lite.json',
  '/business': '/card-inserts/web/business_lite.json',
  '/us': '/card-inserts/web/us_lite.json',
  '/business/budget':
    '/card-inserts/web/business/india-business/budget_lite.json',
  '/sports/cricket': '/card-inserts/web/sports/cricket/ipl.json',
};

function getCityListingPageFeedURL(path, liteversion = false) {
  let apiPath;
  if (path && path !== '') {
    path = path.toLowerCase();
    const pathArr = path.split('/');
    pathArr.shift();
    if (pathArr[0] === 'city' && pathArr.length === 2) {
      if (liteversion === false) {
        apiPath = `/card-inserts/web${path}.json`;
      } else {
        apiPath = `/card-inserts/web${path}_lite.json`;
      }
    }
  }
  return apiPath;
}

export function getCardAPI(path) {
  let apiPath;
  if (path) {
    const lastChar = path.slice(-1);
    if (lastChar && lastChar === '/') {
      path = path.substring(0, path.length - 1);
    }
  }
  apiPath = getCityListingPageFeedURL(path, true);
  if (!apiPath) {
    apiPath = cardAPIMap[path];
  }
  if (!path || !apiPath) {
    return '';
  }

  const cardAPIPath = `${
    __PROD__
      ? 'https://api-newscard.indiatimes.com'
      : 'https://cards-staging.indiatimes.com'
  }${apiPath}`;
  return cardAPIPath;
}

const fullCardAPIMap = {
  '/city/mumbai': '/card-inserts/web/city/mumbai.json',
  '/sports/tokyo-olympics-2021':
    '/card-inserts/web/sports/tokyo-olympics-2021.json',
  '/': '/card-inserts/web/homepage.json',
  '/sports/cricket/icc-mens-t20-world-cup':
    '/card-inserts/web/sports/cricket/icc-mens-t20-world-cup.json',
  '/business/cryptocurrency': '/card-inserts/web/business/cryptocurrency.json',
  '/business': '/card-inserts/web/business.json',
  '/us': '/card-inserts/web/us.json',
  '/business/budget': '/card-inserts/web/business/india-business/budget.json',
  '/sports/cricket': '/card-inserts/web/sports/cricket/ipl.json',
};

export function getFullCardAPI(path) {
  let apiPath;
  if (path && path !== '/') {
    const lastChar = path.slice(-1);
    if (lastChar && lastChar === '/') {
      path = path.substring(0, path.length - 1);
    }
  }
  apiPath = getCityListingPageFeedURL(path);
  if (!apiPath) {
    apiPath = fullCardAPIMap[path];
  }
  if (!path || !apiPath) {
    return '';
  }

  const cardAPIPath = `${
    __PROD__
      ? 'https://api-newscard.indiatimes.com'
      : 'https://cards-staging.indiatimes.com'
  }${apiPath}`;
  return cardAPIPath;
}
